import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { FormActions, FormStatusSwitch } from 'views/Components';

class GrupoContatoForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        isNewRecord: false,
        isView: false,
        grupocontato: {
            codgrupocontato: '',
            descgrupocontato: '',
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descgrupocontato: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição do grupo de contato obrigatória'
                },
                length: { maximum: 100 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    grupocontato: this.getGrupoContatoDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadGrupoContato(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar o grupo de contato:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar o grupo de contato!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o grupo de contato padrão */
    getGrupoContatoDefault = () => ({
        codgrupocontato: '',
        descgrupocontato: '',
        inativo: ANAO
    });

    /* Carrega o grupo de contato */
    loadGrupoContato = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/grupocontato/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Grupo de contato não encontrado!');

            history.push('/crm/grupocontato');

            return;
        }

        this.safeSetState({
            grupocontato: {
                codgrupocontato: registro.codgrupocontato || '',
                descgrupocontato: registro.descgrupocontato || '',
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox' ? (checked ? ANAO : ASIM) : value.toUpperCase();

        this.setState(prevState => ({
            grupocontato: {
                ...prevState.grupocontato,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de grupo de contato */
    getPayloadGrupoContato = () => {
        const { grupocontato } = this.state;

        return {
            descgrupocontato: grupocontato.descgrupocontato || '',
            inativo: grupocontato.inativo || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { grupocontato, isNewRecord } = this.state;
        const { history, loadGrupoContato } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadGrupoContato();

            if (isNewRecord) {
                await api.post('/grupocontato', payload);
            } else {
                await api.put(`/grupocontato/${grupocontato.codgrupocontato}`, payload);
            }

            if (loadGrupoContato) loadGrupoContato();

            history.push('/crm/grupocontato');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/crm/grupocontato');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { grupocontato, schema } = this.state;

        return validateSchemaFields(
            grupocontato,
            schema,
            ['descgrupocontato']
        );
    };

    render() {
        const {
            errors,
            grupocontato,
            isView,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Grupo de contato {grupocontato.codgrupocontato}
                        </Typography>

                        <FormStatusSwitch
                            checked={grupocontato.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descgrupocontato"
                            value={grupocontato.descgrupocontato || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descgrupocontato || ''}
                            error={!!errors.descgrupocontato}
                            disabled={isView}
                            inputProps={{ maxLength: 100 }}
                            fullWidth
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

GrupoContatoForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadGrupoContato: PropTypes.func
};

export default GrupoContatoForm;